<template>
    <div class="full-width">
        <ul class="data-ul">
            <li>
                <h4>{{recordname}}</h4>
            </li>

            <li class="info-part" v-if="null != obj.country">
              <span class="icon-span"><font-awesome-icon icon="fa-solid fa-location-dot" /></span>&nbsp;<span>{{countryname}}</span>(
              <span v-if="dateTimeFlag == -1" style="color: #ff0000;;">{{i18n.tkey("lang_successfully_completed")}}</span>
              <span v-if="dateTimeFlag == 0" style="color: #ffa100;">{{i18n.tkey("lang_exhibition_not_currently")}}</span>
              <span v-if="dateTimeFlag == 1" style="color: #529b2e;">{{i18n.tkey("lang_in_progress")}}</span>)
            </li>

            <li class="info-part">
                <span>{{obj.addinfo3}} - {{obj.addinfo4}}</span>
            </li>

            <li class="img-part" v-if="null != imgUrl">
                <div class="hall-img-box">
                    <img :src="imgUrl">
                </div>
            </li>

            <li class="operation-box">
              <el-button style="margin-top: 5px;" v-if=" dateTimeFlag != -1" type="danger" tkey="申請參展" @click="clickGoApplyBtn">{{i18n.tkey("lang_apply_exhibition")}}</el-button>

             </li>
          <li class="operation-box">
            <el-button style="margin-left: 5px;" v-if=" dateTimeFlag != -1" type="success" tkey="前往3D" @click="clickGoBtn">{{i18n.tkey("lang_goto")}}3D</el-button>
            <el-button style="margin-left: 5px;" v-if=" dateTimeFlag != -1" type="success" tkey="前往3D" @click="clickGo2dBtn">{{i18n.tkey("lang_goto")}}2D</el-button>
            <el-button style="margin-left: 5px;" v-if="dateTimeFlag == -1" type="info" disabled tkey="圓滿完成">{{i18n.tkey("lang_successfully_completed")}}</el-button>

<!--
            <el-button style="margin-left: 5px;" v-if="obj.recordno == -1 && dateTimeFlag == 1" type="success" tkey="前往3D" @click="clickGoBtn">{{i18n.tkey("lang_goto")}}3D</el-button>
            <el-button style="margin-left: 5px;" v-if="obj.recordno == -1 && dateTimeFlag == 1" type="success" tkey="前往3D" @click="clickGo2dBtn">{{i18n.tkey("lang_goto")}}2D</el-button>
            <el-button style="margin-left: 5px;" v-if="(obj.recordno == 0 || dateTimeFlag == 0)&&dateTimeFlag != -1" type="info" disabled tkey="未開放">{{i18n.tkey("lang_not_open")}}</el-button>
            <el-button style="margin-left: 5px;" v-if="dateTimeFlag == -1" type="info" disabled tkey="圓滿完成">{{i18n.tkey("lang_successfully_completed")}}</el-button>
-->

          </li>
        </ul>
    </div>
</template>

<script setup>
    import {inject, toRef, ref, onMounted, getCurrentInstance, computed, onBeforeMount} from "vue";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faLocationDot } from '@fortawesome/free-solid-svg-icons'
    import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";

    library.add(faLocationDot)

    const i18n = inject("i18n")
    const userInfoRef = toRef(useUserinfo())

    const props = defineProps(["obj"])
    const emits = defineEmits(["clickGo"])

    const { proxy } = getCurrentInstance()

    const dateTimeFlag = ref(1)

    function clickGoBtn(){
        emits("clickGo", props.obj)
    }
    function clickGoApplyBtn(){

      window.location.href =  proxy.$ShopopeeUrl+`home/3dshopopee/version2/apply.asp?evFlag=1`
    }

    function clickGo2dBtn(){

      proxy.$router.push({path: `/hallSearch/${props.obj.id}`})
    }

    const recordname = computed(() => {
        let name = props.obj.recordname

        if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
            name = props.obj.addinfo6
        }

        return name
    })

    const imgUrl = computed(() => {
        const lang = userInfoRef.value.lang

        let name = ""

        if (lang == "zh" || lang == "szh"){
            name = proxy.$ShopopeeUrl + props.obj.addinfo11
        }else{
            name = proxy.$ShopopeeUrl + props.obj.addinfo12
			if(myUtil.isEmpty(name)){
				name = proxy.$ShopopeeUrl + props.obj.addinfo11
			}
        }

        return name
    })

    const countryname = computed(() => {
        let name = props.obj.country.countryname

        if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
            name = props.obj.country.countryname2
        }

        return name
    })

    onBeforeMount(() => {
        if (myUtil.isNotEmpty(props.obj.addinfo3) && myUtil.isNotEmpty(props.obj.addinfo4)){
            const date1 = new Date(props.obj.addinfo3)
            const date2 = new Date(props.obj.addinfo4)
            const nowDate = new Date()

            if (nowDate.getTime() > date1.getTime() && nowDate.getTime() < date2.getTime()){
                dateTimeFlag.value = 1
            }else if (nowDate.getTime() > date2.getTime()){
              dateTimeFlag.value = -1
            }else{
              dateTimeFlag.value = 0
            }

        }
    })

    onMounted(() => {
    })

</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .img-part {
        width: 100%;
        box-sizing: border-box;
        padding: 15px;
        text-align: center;
    }

    .img-part .hall-img-box {
        position: relative;
        width: 100%;
        box-sizing: border-box;
        padding-top: 60%;
    }

    .img-part .hall-img-box img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: fill;
        top: 0;
        left: 0;
        border: 1px #E4E7ED solid;
    }

    .operation-box {
        text-align: center;
        margin-top: 5px;
    }

    .info-part {
        line-height: 2;
        color: #606266;
    }

    .data-ul {
        list-style: none;
        padding-left: 0;
        text-align: center;
    }

    .icon-span {
        color: #79bbff;
    }
</style>